import React from 'react';
import UserOutputCashHistoryTable from './UserOutputCashHistoryTable';
import groupsSearchItem from '../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(UserOutputCashHistoryTable);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="outputCashHistory"
    listReduceName="authUserOutputCashModule.lists.authUserOutputCashHistoryList"
  />
);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashHistoryTable/index.js